<script lang="ts">
  import { onMount } from "svelte";

  import wishlist from "../store/wishlist";
  import lang from "../lang/language";
  import Wishlist from "./wishlist/Wishlist.svelte";

  let count = wishlist.count;

  let show = false;

  //onMount(() => wishlist.init());

  const hide = () => {
    show = false;
  };
</script>

<div class="cart-wrapper">
  {#if show == true}
    <Wishlist {hide} />
  {/if}

  <button class="cart-info" on:click={() => (show = !show)}>
    <div class="cart-info-text-only emoji">
      {@html lang.wishlist}
    </div>
    <div class="cart-info-inner">
      <div class="cart-instruction emoji">
        {@html lang.search_subsubtitle}
      </div>
      <div class="cart-icon">
        {#if $count > 0}
          <div class="cart-count">
            {$count}
          </div>
        {/if}
        <i class="fas fa-shopping-cart" />
      </div>
    </div>
  </button>
</div>

<style>
  @media screen and (min-width: 700px) {
    .cart-wrapper {
      display: none !important;
    }
  }
  .cart-info-inner {
    display: flex;
    justify-content: space-around;
    height: 100%;
    align-items: center;
  }

  .cart-info-text-only {
    display: none;
    font-size: 1rem;
  }

  .cart-instruction {
    border-right: 1px solid white;
    font-size: 0.8rem;
    text-align: left;
    width: 80%;
    padding: 8px;
  }

  .cart-icon {
    width: 20%;
  }

  i.fas {
    position: relative;
    font-size: 1.8rem;
  }

  @media screen and (max-width: 768px) {
    i.fas {
      font-size: 20px;
    }
  }

  span.count {
    position: absolute;
    color: white;
    width: 1.8rem;
    text-align: center;
    font-size: 0.7rem;
    left: 0px;
    top: 8px;
  }

  @media screen and (max-width: 768px) {
    span.count {
      font-size: 0.5rem;
      width: 20px;
      top: 6px;
    }
  }

  .cart-info {
    height: 80px;
    width: 340px;
    background-color: var(--cart-color);
    border: 1px solid var(--cart-color);
    font-size: 30px;
    line-height: 20px;
    padding: 3px;
    color: white;
    cursor: pointer;
    position: relative;
    float: right;
    display: inline-block;
    transition: all 0.3s;
  }

  .cart-info:hover {
    background-color: var(--cart-hover-color);
    font-size: 35px;
    /*padding: 5px;*/
    transition: all 0.3s;
  }

  @media screen and (max-width: 768px) {
    .cart-info:hover {
      font-size: 30px;
    }
  }

  .cart-wrapper {
    position: fixed;
    z-index: 1002;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 94vw;
    max-width: 340px;
    display: inline-block;
    width: auto;
  }

  .cart-count {
    position: absolute;
    top: -10px;
    right: -1%;
    height: 20px;
    line-height: 20px;
    width: 20px;
    background-color: red;
    color: white;
    border-radius: 20px;
    font-family: inherit;
    text-align: center;
    font-size: 10px;
  }
  @media screen and (max-width: 450px) {
    .cart-wrapper {
      left: 0px;
      transform: none;
      right: 0px;
      max-width: unset;
    }

    .cart-info {
      margin-right: 0px;
      width: 100vw;
    }

    .cart-info:hover {
      font-size: 30px;
    }

    .cart-count {
      right: -0.2%;
    }

    .cart-info-inner {
      display: none;
    }

    .cart-info-text-only {
      display: block;
    }
  }
</style>
